import AuthLayout from "@/components/AuthLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface Props {
  alert: string | null
  notice: string | null
}

function getCsrfToken() {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

export default function ForgotPasswordPage({ alert, notice }: Props) {
  return (
    <AuthLayout
      title="¿Olvidaste tu contraseña?"
      subtitle="Ingresa tu correo y te enviaremos instrucciones para restablecerla"
      alert={alert}
      notice={notice}
    >
      <form method="post" action="/passwords" className="flex flex-col gap-6">
        <input type="hidden" name="authenticity_token" value={getCsrfToken()} />

        <div className="flex flex-col gap-3">
          <Label htmlFor="email">Correo electrónico</Label>
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="username"
            autoFocus
            required
            placeholder="correo@ejemplo.com"
          />
        </div>

        <Button type="submit" className="w-full">
          Enviar instrucciones
        </Button>

        <a
          href="/session/new"
          className="text-center text-sm text-muted-foreground underline-offset-4 hover:underline hover:text-foreground"
        >
          ← Volver al inicio de sesión
        </a>
      </form>
    </AuthLayout>
  )
}
